var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_814","data-name":"Group 814","transform":"translate(0 0.705)"},[React.createElement("path",{"id":"Path_1410","data-name":"Path 1410","d":"M4489.477,2684.248l15.155,15.245-15.155,16.1","transform":"translate(-4464.792 -2684.248)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_1411","data-name":"Path 1411","d":"M4469.3,2721.123h-39.84","transform":"translate(-4429.463 -2705.956)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

RightArrow.defaultProps = {"width":"41.231","height":"32.735","viewBox":"0 0 41.231 32.735"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
